import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MenuIcon from "@material-ui/icons/Menu";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import React from "react";
import clsx from "clsx";
import "./index.css";
import MenuHeader from "./menu";

const drawerWidth = 260;
//-------------------------------------------------------------------------
// Estilos de la cabecera de Pensiones o Inscripciones.
//-------------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: "linear-gradient(135deg, #0d1b3e 0%, #1a3068 100%)",
    boxShadow: "0 4px 20px rgba(13, 27, 62, 0.3)",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    paddingRight: 24,
  },
}));

//-------------------------------------------------------------------------
// JSX de la cabecera de Pensiones o Inscripciones.
//-------------------------------------------------------------------------
export default function Header({ open, setOpen, type }) {
  const classes = useStyles();
  return (
    <>
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={() => setOpen(true)}
            className={open ? "menuButtonHidden" : "menuButton"}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className="title"
            style={{ fontWeight: 600, letterSpacing: "-0.01em" }}
          >
            {type === "inscripciones" ? "📋 Inscripciones" : type === "matricula" ? "🎓 Matrícula" : "📊 Dashboard"}
          </Typography>
          <MenuHeader type={type}/>
        </Toolbar>
      </AppBar>
    </>
  );
}
